module.exports = __webpack_public_path__ + "static/img/回收-act.9ae9d853.png";